<template>
    <div class="bg-light">
        <div class="container space-2">
            <UpdateAvatarForm/>

            <hr class="my-7">

            <FavoriteTagsForm/>

            <hr class="my-7">

            <PersonalInfoForm/>

        </div>
    </div>
</template>

<script>
    import FavoriteTagsForm from "./FavoriteTagsForm";
    import PersonalInfoForm from "./PersonalInfoForm";
    import UpdateAvatarForm from "./UpdateAvatarForm";
    export default {
        name: "EditProfileContent",
        components: {UpdateAvatarForm, PersonalInfoForm, FavoriteTagsForm}
    }
</script>

<style scoped>

</style>